import { isParty, isProd } from 'core/apiClient';

export const getCanSeeSandboxTab = () => {
  // show relevant realms in the current Tenant only
  return isParty || isProd;
};

export const getShouldFetchAvailableDumpFiles = () => {
  return !isProd;
};

export const getIsTenantEnabled = () => {
  return isParty || isProd;
};
